import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { CustomerService } from '@marina/api-client';
import { PortalCustomerContextService } from '../services/portal-customer-context.service';

/** Allows only Boat Club accounts (stub contract/insurance routes + not-applicable page). */
export const boatClubOnlyGuard: CanActivateFn = () => {
  const portalContext = inject(PortalCustomerContextService);
  const customerService = inject(CustomerService);
  const router = inject(Router);

  return portalContext.ensureLoaded(customerService).pipe(
    map(() => {
      if (portalContext.isBoatClub) {
        return true;
      }
      void router.navigate(['/dashboard']);
      return false;
    })
  );
};
